export default {
  addNewRule: {
    id: 'bo_seller-options-shipping-add_rule',
    defaultMessage: 'Add new rule',
  },
  cannotAddNewRule: {
    id: 'bo_seller-options-shipping-cannot_add_rule',
    defaultMessage:
      'You’ve already added shipping rules for all categories. Select the pencil icon to edit them.',
  },
  seeMore: {
    id: 'bo_seller-options-shipping-see_more',
    defaultMessage: '+{count} more',
  },
  free: {
    id: 'bo_seller-options-shipping-free',
    defaultMessage: 'Free',
  },
  shippingProvider: {
    id: 'bo_seller-options-shipping-shipping_provider',
    defaultMessage: 'Shipping provider',
  },
  shippingTime: {
    id: 'bo_seller-options-shipping-shipping_time',
    defaultMessage: 'Shipping time',
  },
  price: {
    id: 'bo_seller-options-shipping-price',
    defaultMessage: 'Price',
  },
  deleteConfirm: {
    id: 'bo_seller-options-shipping-delete_confirm',
    defaultMessage: 'Are you sure?',
  },
  deleteOk: {
    id: 'bo_seller-options-shipping-delete_ok',
    defaultMessage: 'Yes, delete',
  },
  deleteCancel: {
    id: 'bo_seller-options-shipping-delete_cancel',
    defaultMessage: 'No, keep it',
  },
} as const
